module.exports = __webpack_public_path__ + "static/media/1.0f8a2b1a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/avatars/1.png
 ** module id = 416
 ** module chunks = 0
 **/